const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	lista: [],


};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case 'VEICULO_TIPO_MODO_TELA':
			return {
				...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'VEICULO_TIPO_LISTADO':
			return { ...state, lista: action.payload.data };


		case 'VEICULO_TIPO_SET_AGUARDANDO':
			return {
				...state,
				aguardando: action.payload
			};

		default:
			return state;
	}
}
